<template>
  <div class="menu-list">
    <div
      v-for="item in menuList"
      :key="item.id"
      class="menu-item"
      @click="handleClick(item)"
    >
      <div class="menu-item-content">
        <img :src="item.icon" alt="" />
        <span>{{ item.name }}</span>
      </div>
      <div class="menu-item-right">
        <img src="@/assets/style/my-ment-right.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { menuList } from "@/utils/const.js";

export default {
  name: "menuList",
  data() {
    return {
      menuList,
    };
  },
  methods: {
    handleClick(item) {
      switch (item.id) {
        case 1:
          this.$router.push({
            name: item.path,
          });
          break;
        case 2:
          if (process.env.VUE_APP_ENV === "productionApp") {
            this.$JSBridge.send("serviceType", { type: "9" });
          } else {
            this.$toast("当前已是最新版本");
          }
          break;
        case 3:
          if (process.env.VUE_APP_ENV === "productionApp") {
            this.$toast("当前已是APP");
          } else {
            this.$router.push({
              path: "/landingPageResule",
            });
          }
          break;
        case 4:
          this.$router.push({
            name: item.path,
          });
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.menu-list {
  margin-top: 16px;
  background: #ffffff;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.03);
  border-radius: 12px;
  padding: 0 26px;
}
.menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  border-bottom: 1px solid #f4f4f4;
}
.menu-item:nth-last-child(1) {
  border-bottom: none !important;
}
.menu-item-content {
  display: flex;
  align-items: center;
}
.menu-item img {
  width: 20px;
  height: 20px;
  margin-right: 12px;
}
.menu-item span {
  font-size: 16px;
  font-family: "Regular";
  color: #333333;
}
.menu-item-right {
  display: flex;
  align-items: center;
}
.menu-item-right img {
  width: 6px;
  height: 11px;
}
</style>
